import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Circular from '../Circular/Circular';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { intransitOrder } from '../../services/orders/orders';


const useStyles = theme => ({
    iconView : {
      color: "gray !important"
    },
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: 200
        }
    },
    note: {
        lineHeight: '0.5em'
    },
    dialog: {
        '& .MuiPaper-root':{
            margin: theme.spacing(1),
            width: 250,
            height: 200  
        }
    },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    }
  });

class IntransitOrder extends Component {
    constructor(props) {
        super(props);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);;
        this.intransitOrder = this.intransitOrder.bind(this);
        this.state = {
            waiting: true,
            success: "danger",
            message: ""
        }
    }

    componentDidMount() {
        this.intransitOrder(this.props.awb);
    }

    intransitOrder(awb) {
        intransitOrder(awb, (order) => {
            if (order) {   
                this.setState({ waiting:false, success: "success", message: "Encomenda atualizada com sucesso para endereçado"});
            } else {
                this.setState({ waiting:false, success: "danger", message: "Encomenda não foi atualizada para endereçado.!"});
            }
        });
    }

    handleClickOpen = () => {
        this.props.onChange(true);
    };

    handleClose = () => {
        this.props.onChange(false);
        this.props.setNotification(this.state.message, this.state.success);
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Dialog className={(this.state.waiting) ? classes.dialog : null}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Atualizando Encomenda"}</DialogTitle>
                    <DialogContent>
                    {(this.state.waiting) ? <div><Circular/></div> 
                    : this.handleClose() }
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(useStyles)(IntransitOrder);